/**
 * Created by gavin on 19/2/15.
 */
import axios from "../../utils/axios";

// 用户等级
export function getInfo(query) {
    return axios({
        url: "sysComRate/getInfo",
        method: "get",
        params: query
    });
}

export function edit(query) {
    return axios({
        url: "sysComRate/edit",
        method: "post",
        params: query
    });
}

